import { PayloadAction } from '@reduxjs/toolkit'
import { reducerCreatorProducer } from 'store/common'
import { IAiLibImageState, IImageFilters } from 'store/types/aiLibImage'
import { IAIImageProject } from 'store/types/aiImage'
import { getInitialState } from 'store/features/aiLibImage/initialState'

const reducers = reducerCreatorProducer<IAiLibImageState>()({
  resetFilters: state => {
    state.filters = getInitialState().filters
  },
  toggleFiltersOpen: state => {
    state.isFiltersOpen = !state.isFiltersOpen
  },
  closeFilters: state => {
    state.isFiltersOpen = false
  },
  setFilter: (state, action: PayloadAction<Partial<IImageFilters>>) => {
    state.filters = { ...state.filters, ...action.payload }
  },
  setIsLoaded: (state, action: PayloadAction<boolean>) => {
    state.isLoaded = action.payload
  },
  setIsInitialLoading: (state, action: PayloadAction<boolean>) => {
    state.isInitialLoading = action.payload
  },
  setIsLoadingMore: (state, action: PayloadAction<boolean>) => {
    state.isLoadingMore = action.payload
  },
  setHistoryList: (state, action: PayloadAction<IAIImageProject[]>) => {
    state.historyList = action.payload
  },
  appendHistoryList: (state, action: PayloadAction<IAIImageProject[]>) => {
    state.historyList.push(...action.payload)
  },
  setHistoryTotalCount: (state, action: PayloadAction<number>) => {
    state.historyTotalCount = action.payload
  }
})

export default reducers
